<template>
  <div class="index">
 <Title titleName='提现' iconLeft="back"/>
    <div class="top">
      <img src="../../assets/news1.png" />
      <div class="font">
        <h2>支付宝</h2>
        <p>{{user.store_phone}}</p>
      </div>
    </div>
	<div class="brave">
		<div class="win">
			<div class="leave">
				<div class="l3">
					<div class="nt">提现金额(元)</div>
				</div>
			
			
				<div class="l2">
					
					<div class="lab">￥</div>
					<input v-model="money" placeholder="请输入提现金额" />
					<div class="cid" @click="money=user.store_info.balance">全部提现</div>			
				</div>
        <div class="l4">
          可提现:￥{{user.store_info.balance}}
        </div>
        <div class="l5">
          <p>每日可提现1次</p>
          <p>体现暂不收取手续费</p>
          <p>单笔提现金额上限为5000元</p>
        </div>
			
			</div>
<!--      <ul>-->
<!--        &lt;!&ndash; <li :class="{'wind':type==1}" @click="type=1">-->
<!--          <img src="../../assets/icon8.png" />-->
<!--          <div>-->
<!--            <h4>微信提现</h4>-->
<!--            <p>{{user.nickname}}</p>-->
<!--          </div>-->
<!--        </li> &ndash;&gt;-->
<!--        <li :class="{'wind':type==2}" @click="type=2">-->
<!--          <img src="../../assets/news1.png" />-->
<!--          <div>-->
<!--            <h4>支付宝</h4>-->
<!--            <p>{{user.store_info.store_phone}}</p>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
			<div class="honor">
				
				<div class="h-button" @click="blue">
					确认提现
				</div>
			</div>
		</div>
	</div>




  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
export default {
  components: {
    Title
  },
  data() {
    return {
		title:'',
		channel_id:0,
		images:[],
		info:'',
		user:'',
		weight:'',
		page:1,
		money:0,
		type:2,
		news:[],
		notice:[],
		name:'',
		hans:'',
		sfznum:'',
		phone:'',
		tip:''

    };
  },  mounted() {
 this.channel_id = this.$route.query.id;
this.seat()
	this.sandMate();
		
		
		},methods: {
			
			  seat(){
			  	this.user = JSON.parse(window.localStorage.getItem('user'));
          // this.user={"id":121,"avatar":"https:\/\/thirdwx.qlogo.cn\/mmopen\/vi_32\/Q0j4TwGTfTJU3ne8IMOBdRwamayX9jaWZWDA0rZn6AeetWzAHkCzvQ0hktyibFv6qsxKjoMLrvxKZtAmmzpyUvg\/132","nickname":".\u59dc.\u540c.\u5b66.","sex":0,"province":"","city":"","country":"","openid":"oHb-H5rwfChXqYliuUjuqsfJ0Qwo","unionid":"","store_name":"1","store_phone":"1236199","store_level":1,"store_province":"","store_city":"\u5317\u4eac\u5e02","store_city_id":110100,"store_country":"","store_pos_str":"","store_state":2,"remark":"","created_at":"2022-10-19 18:19:51","updated_at":"2022-12-02 19:03:02","no_pop":1,"store_info":{"id":69,"store_id":121,"freeze_money":0,"settle_money":0,"balance":0.31,"points":0,"order_count":28,"out_ticket_count":4,"refund_ticket_count":24,"alipay_account":"425","alipay_name":"458","draw_rate":"14.3","mean_time":14,"taking_mode":0,"taking_auto":1,"taking_time":"00:00-23:59","cinemas":null,"created_at":"2022-10-19 18:23:00","updated_at":"2022-12-03 17:46:59","today_money":0,"tongji":{"totalMoney":0.31,"totalNumber":4,"todayMoney":0,"todayNumber":0,"yesterMoney":0,"yesterNumber":0,"monthMoney":0.11,"monthNumber":2}},"teyue":"<p>\u5c0a\u656c\u7684\u5408\u4f5c\u5546\uff0c\u611f\u8c22\u60a8\u4e3a\u5e73\u53f0\u7528\u6237\u63d0\u4f9b\u7269\u7f8e\u4ef7\u5ec9\u7684\u4ea7\u54c1\u548c\u8d27\u6e90\uff0c\u672c\u5e73\u53f0\u4e5f\u4f1a\u5f00\u653e\u4e00\u4e9b\u7279\u7ea6\u81ea\u6709\u6743\u76ca\uff0c\u5982\u80af\u5fb7\u57fa\uff0c\u9ea6\u5f53\u52b3\uff0c\u559c\u8336\uff0c\u661f\u5df4\u514b\uff0c\u9910\u996e\u7f8e\u98df\uff0c\u5927\u724c\u86cb\u7cd5\uff0c\u5927\u724c\u5361\u5377\uff0c\u5168\u56fd\u7535\u8d39\uff0c\u8bdd\u8d39\uff0c\u5728\u7ebf\u70b9\u5355\uff0c\u5145\u503c\u7b49\u6743\u76ca\uff0c\u4e3a\u7528\u6237\u63d0\u4f9b\u66f4\u4f18\u60e0\uff0c\u4fbf\u6377\u7684\u672c\u5730\u751f\u6d3b\u670d\u52a1\u3002\u63d0\u4f9b\u6280\u672f,\u7a0b\u5e8f,\u4f9b\u5e94\u94fe\u6761\u6276\u6301\uff0c\u6b22\u8fce\u5408\u4f5c\u5546\u5165\u9a7b\u5171\u8d62\u3002\u671f\u5f85\u60a8\u7684\u54a8\u8be2\u7559\u8a00\u3002<\/p>","kefu":"4001058582\uff0c18610813939","store_level_txt":"A\u7c7b\u5546\u5bb6"}
			  }
	,sandAlt(){
				this.news=[]
				this.sandMate()
			
			}, blue(){
				
				
			this.$axios({
			      method: "post",
			      url: "stores/apply-withdraw",
			      data:{money:this.money,type:this.type}
			    }).then((res) => {
			    	let data=res.data;
			    			
			    	if(data.code==200){
									
					
						Toast(data.message);
					
			    		
			    	}else{  
					Toast(data.message);
									      
								}
			     
			    });
				
				
				
				
			
			}
		}
};
</script>
<style lang="scss" scoped>
.top{
  display: flex;
  margin: 0.4rem;
  background: white;
  padding: 0.3rem;
  border-radius: 0.2rem;
  .font{
    margin-left: 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
.l4{
  padding: 0.1rem 0 0.3rem 0;
  border-top: 1px solid #0000002b;
  color: red;
  font-size: 0.35rem;
  font-weight: bold;
}
.l5{
  color: #607D8B;
  font-weight: bold;
  p{
    margin: 0.1rem 0;
  }
  padding-bottom: 0.4rem;
}
 .mem-con{
 	 background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png) no-repeat;
 	 background-size: 100%;
	 height: 200px;
 	 font-size: 24px;
 	 color: #fff;
 	 padding: 30px;
 	 .mem-l1{
 	
 		 padding: 40px 0;
 		 h3{
 			margin-top: 30px;
 			 font-size: 34px;
 			 color: #fff;
 		 }
 		 .head{
 			width: 100px;
			height: 100px;
			border-radius: 100px;
			margin-left: 30px;
 		 }
 		 .set{
 			 width: 42px;
 		 }
 		 .shop{
 			 width: 120px;
 			 height: 36px;
 			 border-radius: 18px;
 			 color: #7D7D7D;
 			 background: #fff;
 			 text-align: center;
 			 font-size: 24px;
 			 margin-top: 15px;
 		 }
 		 .mem-sim{
 			 text-align: center;
 			 margin-top: 30px;
 			
 			 p{
 				 color: #fff;
 			 }
 		 }
 		 
 	 }
 	
 }
 .h-button{
	 width: 680px;
	 height: 80px;
	 color: #ffffff;
	 background: #4497ec;
	 border-radius: 40px;
	 text-align: center;
	 line-height: 80px;
	 font-size:30px;
	 margin: 30px auto;
 }
.brave{
	margin-top: 30px;
	width: 100%;
	ul{
		display: flex;
		justify-content: space-between;
		.wind{
			border: 3px solid #FF5E00;
		}
		li{
			//width: 306px;
      width:9.5rem;
			margin-top: 20px;
			height: 112px;
			border: 1px solid #BDBDBD;
			border-radius: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 25px;
			img{
				height: 60px;
				margin-right: 20px;
			}
		}
	}
	.win{
		width: 670px;
		margin: 0 auto;
		.leave{
			border-radius: 20px;
			background: #ffffff;
			padding: 0 50px;
			.l1{
				padding: 40px 0;
				
			}
			.l2{
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 110px;
				font-size: 30px;
				input{
					border: none;
				}
				.cid{
					display: flex;
					align-items: center;
					img{
						width: 30px;
						height: 30px;
					}
				}
			}
			.l3{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 40px;
				.nt{
          font-size: 0.6rem;
          font-weight: bold;
					display: flex;
					
				}
				.btn{
					width: 160px;
					height: 80px;
					background: #FF5E00;
					border-radius: 40px;
					color: #FFFFFF;
					font-size: 28px;
					text-align: center;
					line-height: 80px;
				}
			}
		}
		.far{
			border-radius: 20px;
			background: #ffffff;
			padding: 0 50px;
			margin-top: 30px;
			.l1{
				border-bottom: 1px solid #DDDDDD;
				padding: 40px 0;
				
			}
			.l2{
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #DDDDDD;
				height: 110px;
				.cid{
					display: flex;
					align-items: center;
					img{
						width: 30px;
						height: 30px;
					}
				}
			}
		
		}
		.honor{
			h4{
				color: #222222;
				font-size: 28px;
				font-weight: normal;
				margin-top: 50px;
			}
		}
	}
}

</style>